import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function USDollarIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.4c0 1.326 1.045 2.4 2.333 2.4h2.334c1.288 0 2.333-1.075 2.333-2.4S10.455 8 9.167 8H6.833C5.545 8 4.5 6.925 4.5 5.6s1.045-2.4 2.333-2.4h2.334c1.288 0 2.333 1.075 2.333 2.4M8 2v12" /></svg>
  );
}

export default USDollarIcon;
